import { render, staticRenderFns } from "./tzItem.vue?vue&type=template&id=2a3daf60&scoped=true&"
import script from "./tzItem.vue?vue&type=script&lang=js&"
export * from "./tzItem.vue?vue&type=script&lang=js&"
import style0 from "./tzItem.vue?vue&type=style&index=0&id=2a3daf60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3daf60",
  null
  
)

export default component.exports